import React  from 'react';

import { Link } from "react-router-dom";
import {Button} from 'primereact/button';
const footerButton = (props) => {

    let labelName = 'Add';
    let iconName ='pi-plus';

    if(props.type ==='edit'){
        labelName = 'Update'
        iconName = 'pi-check'
    }

    let addAccess = true;
    let editAccess = true;
    if(props.access !== undefined){
        addAccess = (props.access.addAccess === true && props.access.addAccess!==undefined) ? true : false;
        editAccess = (props.access.editAccess === true && props.access.editAccess!==undefined) ? true : false;
    }
    return(

        
            (props.to !=='') ?
                <div className="mt1">
                    { ((props.type === 'add' && addAccess) || (props.type === 'edit' && editAccess)) ?
                    <Button disabled={props.disabled} style={{float:'right'}} label={labelName} icon={"pi "+iconName} className="ml1" onClick={props.save} />
                    : null
                    }

                    { (props.type === 'add' && addAccess) ?
                        <Button style={{float:'right'}} label="Reset" icon="pi pi-replay" className="ml1 p-button-secondary" onClick={props.reset} /> :
                        <Link to={props.to}><Button style={{float:'right'}} label="Cancel" icon="pi pi-times" className="ml1 p-button-secondary" /></Link>
                    }
                    
                    <Link to={props.to}><Button style={{float:'right'}} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" /></Link>
                        
                </div> 
                :
                <div className="mt1">
                    { ((props.type === 'add' && addAccess) || (props.type === 'edit' && editAccess)) ?
                    <Button disabled={props.disabled} style={{float:'right'}} label={labelName} icon={"pi "+iconName} className="ml1" onClick={props.save} />
                    : null
                    }

                    { (props.type === 'add' && addAccess) ?
                        <Button style={{float:'right'}} label="Reset" icon="pi pi-replay" className="ml1 p-button-secondary" onClick={props.reset} /> :
                        <Button style={{float:'right'}} label="Cancel" icon="pi pi-times" className="ml1 p-button-secondary" onClick={props.reset}/>
                    }
                    
                  
                        
                </div> 
        

        

   )
}

export default footerButton;